import React from 'react';
import { toast } from 'sonner';

const AvailabilityTab = ({ config, setConfig, updateConfigValue, t }) => {
  return (
    <>
      <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem' }}>PLZ-Verfügbarkeit</h3>
      {Object.keys(config.availability).map(country => (
        <div key={country} style={{ marginBottom: '2rem', padding: '1.5rem', background: '#F9F9F9', borderRadius: '8px' }}>
          <h4 style={{ fontWeight: '600', marginBottom: '1rem' }}>{country}</h4>
          <div className="form-group">
            <div className="checkbox-group">
              <input
                type="checkbox"
                checked={config.availability[country].allow_all}
                onChange={(e) => {
                  const newAvailability = { ...config.availability };
                  newAvailability[country].allow_all = e.target.checked;
                  setConfig({ ...config, availability: newAvailability });
                }}
                id={`allow-all-${country}`}
                data-testid={`allow-all-${country}`}
              />
              <label htmlFor={`allow-all-${country}`}>Alle PLZ erlauben</label>
            </div>
          </div>
          {!config.availability[country].allow_all && (
            <div className="form-group">
              <label className="form-label">Erlaubte PLZ-Präfixe (nur Komma-getrennt)</label>
              <input
                type="text"
                defaultValue={config.availability[country].prefixes.join(', ')}
                onBlur={(e) => {
                  const value = e.target.value;
                  const invalidChars = value.match(/[^0-9,\s]/g);
                  if (invalidChars && invalidChars.length > 0) {
                    toast.error(t('toastPlzInvalidChars', { chars: invalidChars.join(', ') }));
                    e.target.value = config.availability[country].prefixes.join(', ');
                    return;
                  }
                  const prefixes = value.split(',').map(s => s.trim()).filter(s => s);
                  const nonNumeric = prefixes.filter(p => !/^\d+$/.test(p));
                  if (nonNumeric.length > 0) {
                    toast.error(t('toastPlzInvalidPrefixes', { prefixes: nonNumeric.join(', ') }));
                    e.target.value = config.availability[country].prefixes.join(', ');
                    return;
                  }
                  updateConfigValue(`availability.${country}.prefixes`, prefixes);
                  toast.success(t('toastPlzUpdated', { country }));
                }}
                className="form-input"
                placeholder="z.B. 67, 78, 88"
                data-testid={`prefixes-${country}`}
              />
              <p style={{ fontSize: '0.75rem', color: '#666', marginTop: '0.5rem' }}>
                Nur Kommas verwenden: z.B. "67, 78, 88" ✓ | "67; 78" ✗ | "67-78" ✗
              </p>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default AvailabilityTab;
